module.exports = __webpack_public_path__ + "img/csst.58c9cb3d.png";